

import "./Hero.css";

export default function Hero() {
  return (
    <section id="top" className="hero">
      <div className="container hero__grid">
        {/* LEFT */}
        <div className="hero__left">
          {/* <div className="hero__kicker">
            Frontend Developer (React) • IT Support • QA
          </div> */}

          <h1 className="hero__title">
            I design clean React interfaces
            <br />
            and keep teams running smoothly.
          </h1>

          {/* <p className="hero__sub">
            I build user-focused web interfaces and support the systems people rely on every day —
            from production React apps to device fleets, access controls, and collaboration tools.
          </p>
          <p className="hero__sub hero__sub--secondary">
             Strong background in troubleshooting, QA testing, system optimization, and user training,
             with a customer-service mindset and process-driven approach.
           </p> */}

          <div className="hero__cta">
            <a className="btn btn--primary" href="#projects">
              See My Work
            </a>
            <a className="btn btn--ghost" href="#contact">
              Get in Touch
            </a>
          </div>

          <div className="hero__meta">
            {/* <span className="chip chip--muted">R. Issouf Zabre</span> */}
            <span className="chip chip--muted">New York, NY</span>
            {/* <span className="chip chip--muted">English · French · Mooré</span> */}

   

            <a
              className="chip"
              href="https://github.com/zabroski"
              target="_blank"
              rel="noreferrer"
            >
              GitHub
            </a>
            <a
              className="chip"
              href="https://www.linkedin.com/in/zabreissouf/"
              target="_blank"
              rel="noreferrer"
            >
              LinkedIn
            </a>
          </div>
        </div>

        {/* RIGHT */}
        <div className="hero__right" aria-hidden="true">
          <div className="heroCard">
            <div className="heroCard__top">
              <div className="dot" />
              <div className="dot" />
              <div className="dot" />
            </div>

            <div className="heroCard__body">
              <div className="codeLine w75" />
              <div className="codeLine w55" />
              <div className="codeLine w90" />
              <div className="codeLine w60" />

              <div className="heroCard__pillRow">
                <span className="pill">React</span>
                <span className="pill">JavaScript</span>
                <span className="pill">Google Workspace</span>
                <span className="pill">IT Support</span>
              </div>
            </div>
          </div>

          <div className="heroGlow" />
        </div>
      </div>
    </section>
  );
}
